import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

/** DD.MM.YYYY - e.g. 19.02.2026 */
export function formatDate(dateStr: string | Date): string {
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
}

/** DD.MM - e.g. 19.02 */
export function formatDateShort(dateStr: string | Date): string {
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}.${mm}`;
}

/** Short weekday - e.g. T2, T3... CN */
export function formatWeekday(dateStr: string | Date): string {
    return new Date(dateStr).toLocaleDateString('vi-VN', { weekday: 'short' });
}

/** Full date with weekday - e.g. Thứ Hai, 19.02.2026 */
export function formatDateFull(dateStr: string | Date): string {
    const d = new Date(dateStr);
    const weekday = d.toLocaleDateString('vi-VN', { weekday: 'long' });
    return `${weekday}, ${formatDate(dateStr)}`;
}
